document.addEventListener("DOMContentLoaded", function () {
    function addView3DButtons() {
        let mainContent = document.querySelector("#MainContent");

        if (mainContent) {
            let mediaList = mainContent.querySelector(".product__media-list");

            if (mediaList) {
                let has3DModel = false;
                let modelMediaIds = [];

                mediaList.querySelectorAll(".product__media-item").forEach(item => {
                    let mediaContainer = item.querySelector(".product-media-container");

                    if (mediaContainer && mediaContainer.classList.contains("media-type-model")) {
                        has3DModel = true;
                        item.classList.add("model-3d-box");
                        let mediaId = item.getAttribute("data-media-id");
                        modelMediaIds.push(mediaId);
                        console.log(mediaId);
                    }
                });

                if (has3DModel) {
                    mediaList.querySelectorAll(".product__media-item").forEach(item => {
                        let mediaContainer = item.querySelector(".product-media-container");

                        if (!(mediaContainer && mediaContainer.classList.contains("media-type-model"))) {
                            item.insertAdjacentHTML("beforeend", `
                                <a href="javascript:;" class="view-3d-model" data-3d-target="">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L1 7L12 12L23 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 17L12 22L23 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 12L12 17L23 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    View in 3D
                                </a>
                            `);
                        }
                    });
                  add3DModelStyles();
                }
            }
        }
    }

    function handleView3DButtonClick(event) {
        if (event.target.closest(".view-3d-model")) {
            let button = event.target.closest(".view-3d-model");
            let mediaList = document.querySelector(".product__media-list");

            if (mediaList) {
                let modelItem = mediaList.querySelector(".model-3d-box");

                if (modelItem) {
                    let mediaId = modelItem.getAttribute("data-media-id");
                    let thumbnailItem = document.querySelector(`.thumbnail-list__item[data-target="${mediaId}"]`);

                    if (thumbnailItem) {
                        let btn = thumbnailItem.querySelector("button");
                        if (btn) btn.click();
                    }
                }
            }
        }
    }
function add3DModelStyles() {
    let style = document.createElement("style");
    style.innerHTML = `
        .product__media-item {
            position: relative;
        }
        a.view-3d-model svg {
            width: 18px;
            margin: -1px 6px 0 0;
        }
        a.view-3d-model {
            font-size: 14px;
            height: 40px;
            min-width: 100px;
            background: #fff;
            display: inline-flex;
            align-items: center;
            line-height: 1;
            padding: 0 16px;
            position: absolute;
            bottom: 20px;
            right: 30px;
            text-decoration:none;
        }
    `;
    document.head.appendChild(style);
}

    addView3DButtons();
    document.addEventListener("click", handleView3DButtonClick);
});

/* ── Peaksta: Clear Cart link in the drawer header ────────────────────────────
   An escape hatch for a cart the customer cannot otherwise fix.

   The free RFID wallets have no remove control of their own, so a cart holding
   nothing but stranded gifts, which is how 47 orders between 31 July and 25 September
   2026 reached checkout, leaves the customer with nothing to click. This gives them
   one thing.

   Why clearing is the right action rather than selectively removing gifts: with an
   empty cart EasyGift's trigger is not met, so it has nothing to re-add and cannot
   fight us. Earlier attempts to reconcile wallet quantities against bag counts ended
   in a tug of war with EasyGift that refreshed the drawer under the customer's hands.
   Clearing cannot do that. It is one action, taken by the customer, and it ends. */
(function () {
  'use strict';

  var LABEL = 'Clear Cart';
  var CLASS = 'wo-clear-cart';

  function injectStyles() {
    if (document.getElementById('wo-clear-cart-styles')) return;
    var style = document.createElement('style');
    style.id = 'wo-clear-cart-styles';
    style.textContent =
      '.' + CLASS + '{' +
        'background:none;border:0;padding:0 14px 0 0;margin-left:auto;' +
        'font-family:inherit;font-size:13px;line-height:1;color:#9A9A9A;' +
        'cursor:pointer;text-decoration:underline;text-underline-offset:2px;' +
        'transition:color .15s ease;white-space:nowrap;' +
      '}' +
      '.' + CLASS + ':hover{color:#1A1A1A;}' +
      '.' + CLASS + '[disabled]{opacity:.5;cursor:default;}';
    document.head.appendChild(style);
  }

  /* Hidden on an empty cart, where it would do nothing and only add clutter. The
     count lives in the heading, rendered by Liquid, so it is accurate after every
     drawer re-render without us having to fetch the cart. */
  function isCartEmpty(header) {
    var count = header.querySelector('.kv-cart-count');
    if (!count) return false;
    return parseInt(count.textContent.trim(), 10) === 0;
  }

  function build() {
    var headers = document.querySelectorAll('.cart-drawer__header .drawer__header');
    for (var i = 0; i < headers.length; i++) {
      var header = headers[i];
      var close = header.querySelector('.drawer__close');
      if (!close) continue;

      var link = header.querySelector('.' + CLASS);
      if (!link) {
        link = document.createElement('button');
        link.type = 'button';
        link.className = CLASS;
        link.textContent = LABEL;
        header.insertBefore(link, close);
      }
      link.style.display = isCartEmpty(header) ? 'none' : '';
    }
  }

  function clearCart(button) {
    button.disabled = true;
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    })
      .then(function () {
        return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        /* The drawer is open, the customer is looking at it, so the theme's own
           renderContents is the right call here. It also opens the drawer, which is
           harmless when it is already open. */
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        }
      })
      .catch(function (err) {
        console.error('[Peaksta] clear cart failed', err);
      })
      .then(function () {
        button.disabled = false;
        build();
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.' + CLASS);
    if (!button || button.disabled) return;
    event.preventDefault();
    clearCart(button);
  });

  /* The drawer is re-rendered on every cart change, which throws our button away, so
     it has to be put back each time. Watch the body, NOT #CartDrawer: several scripts
     redraw the drawer by replacing the whole #shopify-section-cart-drawer section (the
     product page bundle, the cart upsells, the Extra SC3 guard, wo-free-wallets), which
     swaps #CartDrawer for a new element. An observer on the old one goes silent and the
     link only came back on the next page load, so it showed some of the time. Batched
     to one build per frame, and build() is a couple of lookups. */
  function watch() {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; build(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    injectStyles();
    build();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* wo-clear-cart */
